import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { forwardRef } from 'react';

type TextareaProps = Omit<TextFieldProps, 'error' | 'variant' | 'multiline'> & {
  invalid?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ invalid = false, ...props }, ref): JSX.Element => {
    return (
      <TextField
        fullWidth
        multiline
        minRows={4}
        variant="outlined"
        error={invalid}
        inputRef={ref}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';
